import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function SiteFooter() {
    const { pathname } = useLocation();
    const isBooks = pathname.startsWith('/books');

    return (
        <footer className="site-footer">
            <div className="site-footer-inner">
                {isBooks ? (
                    <Link to="/" className="footer-switch">
                        → Software Engineer
                    </Link>
                ) : (
                    <Link to="/books" className="footer-switch">
                        → Author
                    </Link>
                )}

                <div className="footer-meta">
                    <span>© {new Date().getFullYear()} Matthew Brinkmann. All rights reserved.</span>
                    <span className="footer-legal">
                        The works linked from this site are protected by copyright. No copying,
                        redistribution, uploading, publishing, resale, or other distribution is
                        permitted without explicit written permission.
                    </span>
                </div>
            </div>
        </footer>
    );
}
